import { Typography, Box } from '@mui/material';

const DocsSchedule = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        View Time Table
      </Typography>

      <Typography variant="body1" paragraph>
        Once a timetable is generated, you can view, analyze, and export it as
        Excel for further use. The system presents the timetable in an
        easy-to-read format.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Steps to View a Timetable
      </Typography>
      <Typography variant="body1" paragraph>
        To access and review the timetable, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Schedule</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the Schedule/TimeTable version from the dropdown that you
            want to view, by default the lastest one is selected.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the view type - Teacher, Student, or Room.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the particular entity - Teacher, Student, or Room.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            The system will display the schedule in a structured grid format.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Exporting the Timetable
      </Typography>
      <Typography variant="body1" paragraph>
        You can export the generated timetable for offline use. Available export
        options include:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Excel Export:</strong> Download the timetable in an Excel
            spreadsheet format.
          </Typography>
        </li>
        {/* <li>
          <Typography variant="body1">
            <strong>PDF Export:</strong> Generate a PDF version for printing or sharing.
          </Typography>
        </li> */}
      </ul>

      {/* <Typography variant="h2" gutterBottom>
        Making Adjustments
      </Typography>
      <Typography variant="body1" paragraph>
        If any changes are required, you can modify the timetable settings and regenerate it.
        Ensure that all data entries are up to date before re-processing the timetable.
      </Typography> */}
    </Box>
  );
};

export default DocsSchedule;
